import { CSSProperties } from 'react';

type TVideoEmbedProps = {
  id: string;
  type: string;
  time?: string;
  height?: number | string;
  width?: number | string;
  style?: CSSProperties;
};

export function VideoEmbed(props: TVideoEmbedProps) {
  const { id, time, type, height = 300, width = '100%', style } = props;

  const autoplay = true;

  if (type === 'youtube') {
    const videoUrl = `https://www.youtube-nocookie.com/embed/${id}?origin=${encodeURIComponent(RIO_SITE.external_url)}&start=${
      time || ''
    }&autoplay=${autoplay ? '1' : '0'}`;

    return (
      <iframe
        src={videoUrl}
        width={width}
        height={height}
        frameBorder="0"
        scrolling="no"
        allowFullScreen={true}
        style={style}
        allow={`${autoplay ? 'autoplay' : ''}`}
      />
    );
  } else {
    const videoUrl = id
      ? `https://player.twitch.tv/?video=${id}&autoplay=${autoplay ? 'true' : 'false'}&time=${time || '0s'}&parent=${RIO_SITE.external_hostname}`
      : `https://player.twitch.tv/?channel=warcraft&autoplay=${autoplay ? 'true' : 'false'}&parent=${RIO_SITE.external_hostname}`;

    return (
      <iframe
        src={videoUrl}
        width={width}
        height={height}
        frameBorder="0"
        scrolling="no"
        allowFullScreen={true}
        style={style}
        allow={`${autoplay ? 'autoplay' : ''}`}
      />
    );
  }
}
